/* KOLAK QA: convert structured product description headings to accessible accordions. */
(function () {
  function enhance(root) {
    (root || document).querySelectorAll('.description-content').forEach(function(container) {
      if (container.dataset.kolakAccordions === 'true') return;
      var headings = Array.from(container.children).filter(function(el) {
        return el.tagName === 'H3' && /^(The Details|The Construct|Material System|Care Protocol|Size Guide)$/i.test(el.textContent.trim());
      });
      if (!headings.length) return;
      headings.forEach(function(heading) {
        var wrapper = document.createElement('details');
        wrapper.className = 'kolak-product-accordion';
        var summary = document.createElement('summary');
        summary.textContent = heading.textContent.trim();
        wrapper.appendChild(summary);
        var content = document.createElement('div');
        content.className = 'kolak-product-accordion-content';
        while (heading.nextSibling && !(heading.nextSibling.nodeType === 1 && heading.nextSibling.tagName === 'H3')) {
          content.appendChild(heading.nextSibling);
        }
        wrapper.appendChild(content);
        heading.replaceWith(wrapper);
      });
      container.dataset.kolakAccordions = 'true';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){enhance(document);});
  else enhance(document);
  document.addEventListener('shopify:section:load', function(event){enhance(event.target);});
})();